
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M9.496 15.39v-3.906c0-.543-.222-.984-.496-.984s-.496.44-.496.984v3.906c-.031.74.134 1.11.496 1.11s.527-.37.496-1.11z"}}),_c('path',{attrs:{"d":"M.5 9.143a8.674 8.674 0 003.764 7.177 1.028 1.028 0 001.442-.287 1.069 1.069 0 00-.283-1.467 6.554 6.554 0 01-2.845-5.423c0-3.6 2.881-6.53 6.422-6.53s6.422 2.93 6.422 6.53a6.56 6.56 0 01-2.832 5.415c-.476.326-.6.983-.28 1.467.322.483.968.61 1.443.284A8.677 8.677 0 0017.5 9.143C17.5 4.377 13.687.5 9 .5 4.313.5.5 4.377.5 9.143z"}})])])
          )
        }
      }
    